import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AssociationPriceListDestinationService } from 'src/app/services/association-price-list-destination.service';
import { DestinationService } from 'src/app/services/destination.service';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-association-price-list-destination',
  templateUrl: './association-price-list-destination.component.html',
  styleUrls: ['./association-price-list-destination.component.scss']
})
export class AssociationPriceListDestinationComponent {
  loading = false;
  
    allDestinations: any[] = [];
    allPriceLists: any[] = [];
  
    destinations: any[] = [];
    priceLists: any[] = [];
  
    filterDestinations = '';
    filterPriceLists = '';
  
    selectedDestinationId: number | null = null;
    selectedDestination: any = null;
    initialRelatedPriceListIdsBefore: number[] = [];
    currentRelatedPriceListIds: number[] = [];
    currentRelatedPriceLists: any[] = [];
  
    paginationDestinations = new SimplePaginationModel(0, 5, 0, 0, 0);
    paginationPriceLists = new SimplePaginationModel(0, 5, 0, 0, 0);
  
  
    @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;
    @HostListener('window:resize') onResize() { this.drawMultipleLinks(); }
  
    private timeoutDestinations: any = null;
    private timeoutPriceLists: any = null;
  
    constructor(
      private toastService: ToastrService,
      private destinationService: DestinationService,
      private inventoryService: InventoryService,
      private associationService: AssociationPriceListDestinationService
    ) {}
  
    ngOnInit(): void {
      this.loadStartData();
    }
  
    loadStartData() {
      this.loadDestinations();
      this.loadPriceLists();
    }
  
    loadDestinations() {
      this.destinationService.getDestinations().subscribe({
        next: (resp: ResponseObject) => {
          this.allDestinations = resp.data || [];
          this.refreshDestinationsPagination();
        },
        error: () => this.toastService.error('Error al obtener las bodegas')
      });
    }
  
    loadPriceLists() {
      this.inventoryService.getProductPricesList().subscribe({
        next: (resp: ResponseObject) => {
          this.allPriceLists = resp.data || [];
          this.refreshPriceListsPagination();
        },
        error: () => this.toastService.error('Error al obtener las listas de precios')
      });
    }
  
    selectDestination(destinationId: number) {
      if (this.selectedDestinationId === destinationId) return;
  
      this.selectedDestinationId = destinationId;
      this.selectedDestination = this.allDestinations.find(w => w.id === destinationId);
  
      this.currentRelatedPriceListIds = [];
      this.currentRelatedPriceLists = [];
  
      this.associationService.getAssociateCompanies(destinationId).subscribe({
        next: (resp: ResponseObject) => {
          const associations = resp.data || [];
  
          const relatedIds: number[] = associations.map((item: any) => item.priceListId);
  
          this.initialRelatedPriceListIdsBefore = [...relatedIds];
          this.currentRelatedPriceListIds = [...relatedIds];
  
          this.currentRelatedPriceLists = this.allPriceLists.filter(p =>
            relatedIds.includes(p.id)
          );
  
          this.refreshPriceListsPagination();
          this.drawMultipleLinks();
        },
        error: (error) => {
          console.error(error);
          this.toastService.error('Error al obtener asociaciones de la bodega');
        }
      });
    }
  
    togglePriceList(p: any) {
      if (!this.selectedDestinationId) {
        this.toastService.warning('Selecciona primero una bodega.');
        return;
      }
  
      const idx = this.currentRelatedPriceListIds.indexOf(p.id);
      if (idx === -1) {
        this.currentRelatedPriceListIds.push(p.id);
      } else {
        this.currentRelatedPriceListIds.splice(idx, 1);
      }
  
      this.currentRelatedPriceLists = this.allPriceLists.filter(pl =>
        this.currentRelatedPriceListIds.includes(pl.id)
      );
  
      this.refreshPriceListsPagination();
      this.drawMultipleLinks();
    }
  
    getDisabledSave(): boolean {
      const initialSet = new Set(this.initialRelatedPriceListIdsBefore);
      const currentSet = new Set(this.currentRelatedPriceListIds);
  
      const toAdd = this.currentRelatedPriceListIds.some(id => !initialSet.has(id));
      const toRemove = this.initialRelatedPriceListIdsBefore.some(id => !currentSet.has(id));
  
      return !(toAdd || toRemove) || !this.selectedDestinationId || this.loading;
    }
  
    saveAssociation(finalize: boolean) {
      if (!this.selectedDestinationId) return;
  
      const destinationId = this.selectedDestinationId;
  
      const initialSet = new Set(this.initialRelatedPriceListIdsBefore);
      const currentSet = new Set(this.currentRelatedPriceListIds);
  
      const toAdd = this.currentRelatedPriceListIds.filter(id => !initialSet.has(id));
      const toRemove = this.initialRelatedPriceListIdsBefore.filter(id => !currentSet.has(id));
  
      if (toAdd.length === 0 && toRemove.length === 0) {
        this.toastService.info('No hay cambios por guardar.');
        return;
      }
  
      this.loading = true;
  
      const ops = [
        ...toAdd.map(pid => this.associationService.createRelationDestinationPriceList(destinationId, pid)),
        ...toRemove.map(pid => this.associationService.deleteRelationDestinationPriceList(destinationId, pid))
      ];
  
      forkJoin(ops).subscribe({
        next: () => {
          this.toastService.success('Asociaciones actualizadas correctamente', 'Éxito');
          this.loading = false;
          this.selectDestination(destinationId);
          if (finalize) this.toastService.info('Asociación finalizada correctamente.');
        },
        error: (e: HttpErrorResponse) => {
          this.toastService.error(e?.error?.message || 'Error al actualizar asociaciones', 'Error');
          this.loading = false;
        }
      });
    }
  
    debouncedFilterDestinations() {
      clearTimeout(this.timeoutDestinations);
      this.timeoutDestinations = setTimeout(() => {
        this.paginationDestinations.page = 0;
        this.refreshDestinationsPagination();
      }, 250);
    }
  
    refreshDestinationsPagination() {
      const q = (this.filterDestinations || '').toLowerCase();
      const filtered = this.allDestinations.filter(w =>
        (w.name || '').toLowerCase().includes(q) ||
        (w.code || '').toLowerCase().includes(q)
      );
  
      this.paginationDestinations.total = filtered.length;
      this.paginationDestinations.start = this.paginationDestinations.page * this.paginationDestinations.size;
      const end = this.paginationDestinations.start + this.paginationDestinations.size;
      this.paginationDestinations.end = Math.min(end, filtered.length);
  
      this.destinations = filtered.slice(this.paginationDestinations.start, this.paginationDestinations.end);
      this.drawMultipleLinks();
    }
  
    debouncedFilterPriceLists() {
      clearTimeout(this.timeoutPriceLists);
      this.timeoutPriceLists = setTimeout(() => {
        this.paginationPriceLists.page = 0;
        this.refreshPriceListsPagination();
      }, 250);
    }
  
    refreshPriceListsPagination() {
      const q = (this.filterPriceLists || '').toLowerCase();
      const matches = (p: any) =>
        (p.name || '').toLowerCase().includes(q) ||
        (p.description || '').toLowerCase().includes(q);
  
      const associatedSet = new Set(this.currentRelatedPriceListIds);
      const pinned = this.allPriceLists.filter(p => associatedSet.has(p.id));
      const rest = this.allPriceLists.filter(p => !associatedSet.has(p.id) && matches(p));
  
      const final = [...pinned, ...rest];
  
      this.paginationPriceLists.total = final.length;
      this.paginationPriceLists.start = this.paginationPriceLists.page * this.paginationPriceLists.size;
      const end = this.paginationPriceLists.start + this.paginationPriceLists.size;
      this.paginationPriceLists.end = Math.min(end, final.length);
  
      this.priceLists = final.slice(this.paginationPriceLists.start, this.paginationPriceLists.end);
      this.drawMultipleLinks();
    }
  
    drawMultipleLinks() {
      const svg = this.svgContainer?.nativeElement as SVGElement;
      if (!svg) return;
  
      svg.innerHTML = '';
  
      if (!this.selectedDestinationId || this.currentRelatedPriceListIds.length === 0) return;
  
      setTimeout(() => {
        const parentRect = (svg.parentElement as HTMLElement).getBoundingClientRect();
        const selectedRow = document.querySelector('#table-destinations tr.selected') as HTMLElement;
        if (!selectedRow) return;
  
        const selectedRect = selectedRow.getBoundingClientRect();
        const x1 = selectedRect.right - parentRect.left - 12;
        const y1 = selectedRect.top + selectedRect.height / 2 - parentRect.top;
  
        for (const pid of this.currentRelatedPriceListIds) {
          const relatedRow = document.querySelector(`#table-pricelists tr[data-id="${pid}"]`) as HTMLElement;
          if (!relatedRow) continue;
  
          const rect = relatedRow.getBoundingClientRect();
          const x2 = rect.left - parentRect.left - 12;
          const y2 = rect.top + rect.height / 2 - parentRect.top;
          const xMiddle = x1 + ((x2 - x1) / 2);
  
          this.drawLine(svg, x1, xMiddle, y1, y1);
          this.drawLine(svg, xMiddle, x2, y2, y2);
          this.drawLine(svg, xMiddle, xMiddle, y1, y2);
        }
      }, 50);
    }
  
    private drawLine(svg: SVGElement, x1: number, x2: number, y1: number, y2: number) {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', String(x1));
      line.setAttribute('y1', String(y1));
      line.setAttribute('x2', String(x2));
      line.setAttribute('y2', String(y2));
      line.setAttribute('stroke', '#14532d');
      line.setAttribute('stroke-width', '2');
      svg.appendChild(line);
    }
}
